import { withTranslation } from "next-i18next";
import { memo } from "react";
import { useFiltersList } from "@hooks/use-features";
import shouldHideFilterSectionInListingPage from "@utils/catalog-filters/shouldHideFilterSectionInListingPage";
import SectionButton from "./Elements/SectionButton";
import SectionContent from "./Elements/SectionContent";
import FilterCheckbox from "./Elements/FilterCheckbox";

const filterSectionKey = "length";

const LengthSection = memo(function LengthSection({
  sleeveItems,
  legItems,
  refineSleeve,
  refineLeg,
  listingPage,
  onClose,
  filterSectionOpened,
  setFilterSectionOpened,
  t,
}) {
  const filtersList = useFiltersList();

  if (shouldHideFilterSectionInListingPage(listingPage, "sleeves")) return null;
  if (shouldHideFilterSectionInListingPage(listingPage, "legs")) return null;
  if (sleeveItems.length + legItems.length < 2) return null;

  const sectionTitle = t(`catalog:filters.section_titles.${filterSectionKey}`);

  function displaySleevesFiltersOptions() {
    return filtersList.sleeves.map((filter) => {
      const item = sleeveItems.find((item) => item.value === filter);

      if (!item) return;

      return (
        <FilterCheckbox
          key={`filter-${filter}`}
          label={t(`catalog:filters.sleeves.${filter}`)}
          filterType="sleeves"
          filterSectionKey={filterSectionKey}
          item={item}
          refine={refineSleeve}
        />
      );
    });
  }

  function displayLegsFiltersOptions() {
    return filtersList.legs.map((filter) => {
      const item = legItems.find((item) => item.value === filter);

      if (!item) return;

      return (
        <FilterCheckbox
          key={`filter-${filter}`}
          label={t(`catalog:filters.legs.${filter}`)}
          filterType="legs"
          filterSectionKey={filterSectionKey}
          item={item}
          refine={refineLeg}
        />
      );
    });
  }

  const checkedFilters = {
    sleeves: sleeveItems
      .filter((sleeveItem) => sleeveItem.isRefined)
      .map((sleeveItem) => sleeveItem.value),
    legs: legItems.filter((legItem) => legItem.isRefined).map((legItem) => legItem.value),
  };

  return (
    <div>
      <SectionButton
        checkedFilters={checkedFilters}
        filterTypesToDisplay={["sleeves", "legs"]}
        title={sectionTitle}
        onClick={() => setFilterSectionOpened(filterSectionKey)}
      />
      <SectionContent
        isOpen={filterSectionOpened === filterSectionKey}
        onClose={onClose}
        onGoBack={() => setFilterSectionOpened("")}
        title={sectionTitle}
      >
        <div className="d-flex flex-column gap-2">
          {sleeveItems.length > 0 && (
            <div>
              <div className="px-3 pt-3 pb-2">
                <p className="mb-0 text-gray">{t("catalog:filters.sleeves.title")}</p>
              </div>
              {displaySleevesFiltersOptions()}
            </div>
          )}

          {legItems.length > 0 && (
            <div>
              <div className="px-3 pt-3 pb-2">
                <p className="mb-0 text-gray">{t("catalog:filters.legs.title")}</p>
              </div>
              {displayLegsFiltersOptions()}
            </div>
          )}
        </div>
      </SectionContent>
    </div>
  );
});

export default withTranslation("catalog")(LengthSection);
